import { differenceInSeconds, format, isToday } from "date-fns";
import { utcToZonedTime } from "date-fns-tz";
import ct from "countries-and-timezones";
import { LocationEvents, SummaryEvent } from "@jugl-web/rest-api";
import { addZ } from "./addZ";

export const workdayDurationCalculator = (
  events: SummaryEvent[],
  date: string,
  userTimezone?: string
) => {
  const { timeZone } = Intl.DateTimeFormat().resolvedOptions();
  const timezoneInfo = ct.getTimezone(userTimezone || timeZone);
  const dayEvents = events
    .filter(
      (element) =>
        element.start_time &&
        format(
          utcToZonedTime(addZ(element.start_time), userTimezone || timeZone),
          "yyyy-MM-dd"
        ).includes(date)
    )
    .sort((a, b) => {
      const aStartTime = utcToZonedTime(
        addZ(a.start_time),
        userTimezone || timeZone
      );
      const bStartTime = utcToZonedTime(
        addZ(b.start_time),
        userTimezone || timeZone
      );
      return aStartTime.getTime() - bStartTime.getTime();
    });
  const startEvent = dayEvents?.[0];
  const isTodayDate = isToday(new Date(date));
  if (startEvent?.type === LocationEvents.clock_in && dayEvents?.length === 1) {
    const seconds = differenceInSeconds(
      isTodayDate
        ? utcToZonedTime(new Date().toISOString(), userTimezone || timeZone)
        : utcToZonedTime(
            new Date(`${date} 23:59:59 ${timezoneInfo?.dstOffsetStr}`),
            userTimezone || timeZone
          ),
      utcToZonedTime(addZ(startEvent.start_time), userTimezone || timeZone)
    );
    return seconds;
  }
  if (dayEvents && dayEvents.length > 1) {
    let totalValue = 0;
    dayEvents?.forEach((element, index) => {
      const isBreakType =
        element.type === LocationEvents.clock_out ||
        element.type === LocationEvents.paused ||
        element.type === LocationEvents.offline;
      const isPreviousBreakType =
        dayEvents[index - 1]?.type === LocationEvents.clock_out ||
        dayEvents[index - 1]?.type === LocationEvents.paused ||
        dayEvents[index - 1]?.type === LocationEvents.offline;
      const dur = differenceInSeconds(
        utcToZonedTime(addZ(element.start_time), userTimezone || timeZone),
        utcToZonedTime(
          addZ(dayEvents[index - 1]?.start_time),
          userTimezone || timeZone
        )
      );
      const isLastOne = index + 1 === dayEvents.length;
      if (index === 0) {
        return;
      }
      if (isBreakType) {
        if (!isPreviousBreakType) {
          totalValue += dur;
        }
      }
      if (isLastOne && !isBreakType) {
        const currentTime = utcToZonedTime(
          new Date(),
          userTimezone || timeZone
        );
        const endTime =
          date === format(currentTime, "yyyy-MM-dd")
            ? new Date()
            : new Date(`${date}T23:59:59${timezoneInfo?.dstOffsetStr}`);

        const seconds = differenceInSeconds(
          utcToZonedTime(endTime, userTimezone || timeZone),
          utcToZonedTime(addZ(element.start_time), userTimezone || timeZone)
        );
        totalValue += seconds;
      }
      if (!isBreakType && !isPreviousBreakType) {
        totalValue += dur;
      }
    });
    return Number(totalValue.toFixed(0));
  }
  return 0;
};
